module.exports = __webpack_public_path__ + "img/empty-img-default.8157b5cb.svg";